import React, {useEffect, useState} from "react";
import loadCorridors from "../services/viewerFuncs/getCorridors";
import {Select } from '@chakra-ui/react'
import { useAuthState } from '../Context';


function CorridorDropDown(props) {
    const userDetails = useAuthState()
    const [corridors, setCorridors] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const fetchCorridors = () =>{
        loadCorridors(userDetails.token)
            .then((response) =>{
            setIsLoading(false)
            setCorridors(response.data.availConfs)
                for(let i = 0; i<response.data.availConfs.length;i++)
                {
                    console.log(JSON.stringify(response.data.availConfs[i]))
                }
        })
            .catch((error) =>{
                setIsLoading(false)
                setIsError(true)
                console.log(error)
            })
    }


    useEffect(() =>{
        fetchCorridors()
    }, [])
    if (isLoading){
        return <div>Loading...</div>
    }
    return (
        <Select
            placeholder={props.dataset === undefined ?  ("Select a corridor"):(props.dataset)}
            onChange={(value) => props.chooseDataset(value)}>
            {corridors.map(corr => {
                if (!corr.label.includes("NBX_BQBG_YBIR_PBHAGL_KTX") && !corr.label.includes("NBX_BQBG_YBIR_PBHAGL")) {
                    return <option value={corr.dir} key={corr.dir}>{corr.label}</option>
                }
            })}
        </Select>
    )
}

export default CorridorDropDown



